export const marcas: string[] = [
    "Toyota",
    "Honda",
    "Ford",
    "Chevrolet",
    "BMW",
    "Mercedes-Benz",
    "Audi",
    "Volkswagen",
    "Hyundai",
    "Nissan",
    "Kia",
    "Subaru",
    "Mazda",
    "Dodge",
    "Jeep",
    "Tesla",
    "Lexus",
    "Acura",
    "Infiniti",
    "Porsche",
    "Jaguar",
    "Land Rover",
    "Mitsubishi",
    "Fiat",
    "Alfa Romeo",
    "Volvo",
    "Mini",
    "Cadillac",
    "Lincoln",
    "Buick"
];
